var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app_config_cla" },
    [
      _vm.appConfigList.length !== 0
        ? _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _vm._l(_vm.appConfigList, function(item) {
                return [
                  _c("div", { key: item.id }, [
                    _c("span", { staticClass: "config-title-cla" }, [
                      _vm._v(_vm._s(item.name))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "app_config_des" }, [
                      _vm._v(
                        "\n          " + _vm._s(item.remark) + "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "app_associated_cla" }, [
                      _c("div", { staticStyle: { "text-align": "center" } }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("developer.assApplication")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "app_ass_num" }, [
                          _c(
                            "span",
                            {
                              class:
                                _vm.countAppConfig.opens === 0 ||
                                _vm.countAppConfig.opens === undefined
                                  ? "color__error"
                                  : "color__primary"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.countAppConfig.opens
                                    ? _vm.countAppConfig.opens
                                    : 0
                                )
                              )
                            ]
                          ),
                          _vm._v(
                            "\n              / " +
                              _vm._s(
                                _vm.countAppConfig.alls
                                  ? _vm.countAppConfig.alls
                                  : 0
                              )
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.toConfigUrl }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("developer.config")) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ]
              })
            ],
            2
          )
        : _c("zkNoData")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e513a85a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e513a85a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/developer/appConfigSetting.vue
// module id = null
// module chunks = 